"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MemberEntry;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _MemberEntryModule = _interopRequireDefault(require("./MemberEntry.module.scss"));

var _MemberEntry = _interopRequireDefault(require("./MemberEntry.i18n"));

var _ClassSkill = _interopRequireDefault(require("../../../../../../entities/skills/ClassSkill/ClassSkill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function MemberEntry(_ref) {
  var character = _ref.character,
      isSelected = _ref.isSelected,
      onSelect = _ref.onSelect,
      _ref$showEnergyValues = _ref.showEnergyValuesOnHover,
      showEnergyValuesOnHover = _ref$showEnergyValues === void 0 ? false : _ref$showEnergyValues;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var name = character.name,
      level = character.level,
      characterClass = character.characterClass,
      energy = character.energy,
      statusEffects = character.statusEffects;
  var hp = energy.hp,
      hpMax = energy.hpMax,
      mp = energy.mp,
      mpMax = energy.mpMax,
      sp = energy.sp,
      spMax = energy.spMax;
  var characterClassId = characterClass.id;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      areEffectsVisible = _useState2[0],
      setAreEffectsVisible = _useState2[1];

  var handleSelect = (0, _react.useCallback)(function () {
    if (onSelect) onSelect();
  }, [onSelect]);
  var renderIcon = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_MemberEntryModule.default.icon, _MemberEntryModule.default[characterClassId]),
      onClick: function onClick() {
        return setAreEffectsVisible(!areEffectsVisible);
      }
    });
  }, [characterClassId, areEffectsVisible]);
  var renderEnergy = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_MemberEntryModule.default.energy, showEnergyValuesOnHover && _MemberEntryModule.default.showValuesOnHover)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_MemberEntryModule.default.bar, _MemberEntryModule.default.hp)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.fill,
      style: {
        width: "".concat(100 * hp / hpMax, "%")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.value
    }, hp, " / ", hpMax)), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_MemberEntryModule.default.bar, _MemberEntryModule.default.mp)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.fill,
      style: {
        width: "".concat(100 * mp / mpMax, "%")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.value
    }, mp, " / ", mpMax)), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_MemberEntryModule.default.bar, _MemberEntryModule.default.sp)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.fill,
      style: {
        width: "".concat(100 * sp / spMax, "%")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.value
    }, sp, " / ", spMax)));
  }, [hp, hpMax, mp, mpMax, sp, spMax, showEnergyValuesOnHover]);
  var renderStatusEffects = (0, _react.useCallback)(function () {
    var renderStatusEffect = function renderStatusEffect(statusEffect) {
      var id = statusEffect.id,
          isAboutToExpire = statusEffect.isAboutToExpire,
          byClassSkill = statusEffect.byClassSkill;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: id,
        className: (0, _classnames.default)(_MemberEntryModule.default.entry, isAboutToExpire && _MemberEntryModule.default.blink)
      }, /*#__PURE__*/_react.default.createElement(_ClassSkill.default, {
        skill: byClassSkill,
        className: _MemberEntryModule.default.skill
      }), " ");
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.statusEffects
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.positive
    }, statusEffects.filter(function (entry) {
      return entry.isNegative === false;
    }).map(renderStatusEffect)), /*#__PURE__*/_react.default.createElement("div", {
      className: _MemberEntryModule.default.negative
    }, statusEffects.filter(function (entry) {
      return entry.isNegative === true;
    }).map(renderStatusEffect)));
  }, [statusEffects]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MemberEntryModule.default.entry, isSelected && _MemberEntryModule.default.selected, !areEffectsVisible && _MemberEntryModule.default.hiddenEffects)
  }, renderIcon(), /*#__PURE__*/_react.default.createElement("div", {
    className: _MemberEntryModule.default.stats,
    onClick: handleSelect
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MemberEntryModule.default.name
  }, name), /*#__PURE__*/_react.default.createElement("div", {
    className: _MemberEntryModule.default.level
  }, formatMessage(_MemberEntry.default.lv), " ", level), renderEnergy()), areEffectsVisible && renderStatusEffects());
}